const IMAGES = {
  // LOGO
  logo: require("../img/logo.png"),
  //HOME
  hero1: require("../img/home/hero1.jpg"),
  hero2: require("../img/home/hero2.jpg"),
  hero3: require("../img/home/hero3.webp"),
  hero4: require("../img/home/hero4.png"),
  homeabout: require("../img/home/homeabout.jpg"),
  safe: require("../img/products/safe.png"),
  video: require("../img/teaching.mp4"),
  //about
  about: require("../img/about/bake.jpeg"),
  abouts: require("../img/about/about.jpg"),
  barcode: require("../img/barcode.jpeg"),
  //Reviews
  r1: require("../img/rv/1.jpg"),
  r2: require("../img/rv/2.jpg"),
  r3: require("../img/rv/3.jpg"),
  r4: require("../img/rv/4.jpeg"),
  r5: require("../img/rv/5.jpeg"),
  r6: require("../img/rv/6.jpeg"),
  r7: require("../img/rv/7.jpeg"),
  r8: require("../img/rv/8.jpeg"),
  r9: require("../img/rv/9.jpeg"),
  //videos
  v1: require("../video/1.mp4"),
  v2: require("../video/2.mp4"),
  v3: require("../video/3.mp4"),
  v4: require("../video/4.mp4"),
  v5: require("../video/5.mp4"),
  v6: require("../video/6.mp4"),
  v7: require("../video/7.mp4"),
  v8: require("../video/8.mp4"),
  v9: require("../video/9.mp4"),
  v10: require("../video/10.mp4"),

  //
  one: require("../img/home/1.jpg"),
  two: require("../img/home/2.jpg"),
  three: require("../img/home/3.jpg"),
  four: require("../img/home/4.jpg"),
};

export default IMAGES;
